/** Shared, understated feature marker for builder-facing tools. */
export function NewFeatureBadge({ testId }: { testId?: string }) {
  return <span data-testid={testId} className="inline-flex shrink-0 items-center rounded border border-amber-200 bg-amber-50 px-1.5 py-0.5 text-[9px] font-semibold leading-none text-amber-700 dark:border-amber-800 dark:bg-amber-950/30 dark:text-amber-300">New</span>;
}
